const TRANSLATION_NAMESPACE = 'jbp-uam-access-denied'

export const TRANSLATION_KEYS = {
  greetings: `${TRANSLATION_NAMESPACE}--greetings-title`,
  warningMessage: `${TRANSLATION_NAMESPACE}--warning-message`,
  requestAccessMessage: `${TRANSLATION_NAMESPACE}--request-access-message`,
  support: `${TRANSLATION_NAMESPACE}--support`,
  requestProfile: `${TRANSLATION_NAMESPACE}--request-profile`,
}
